import useLoadChartsData from "../../hooks/useLoadChartsData";

const DataLoader = () => {
  useLoadChartsData();
  return null;
};

export default DataLoader;
